import { getActionTypesForService } from 'shared/utils/createServiceStore.js';
import { TUNNEL_SERVICE_KEY } from './tunnelEnum.js';

export default getActionTypesForService(TUNNEL_SERVICE_KEY);
